<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <!-- Creator: CorelDRAW 2020 (64 Bit) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="411px"
    height="450px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 32.26 35.29"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs>
      <font
        id="FontID0"
        horiz-adv-x="778"
        font-variant="normal"
        style="fill-rule: nonzero"
        font-weight="900"
      >
        <font-face font-family="Arial Black">
          <font-face-src>
            <font-face-name name="Arial Black Normal" />
          </font-face-src>
        </font-face>
        <missing-glyph><path d="M0 0z" /></missing-glyph>
        <glyph
          unicode="I"
          horiz-adv-x="389"
          d="M82.0237 716.229l222.073 0 0 -716.229 -222.073 0 0 716.229z"
        />
      </font>
    </defs>
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M15.15 28.36l0.01 2.82c-0.57,0.01 -3.49,-0.46 -4.24,-0.58 -2.32,-0.37 -5.66,-1.03 -7.81,-1.84 -0.59,-0.23 -1.14,-0.46 -1.62,-0.8 -0.37,-0.26 -0.29,-0.38 -0.29,-0.91 0,-0.41 0.01,-0.83 0,-1.23 -0.28,-0.11 -0.66,-0.44 -0.89,-0.66l-0.29 -0.25c-0.01,0.72 0,1.45 0,2.17 -0.01,0.79 -0.12,1.35 0.27,1.95 0.45,0.68 1.71,1.3 2.68,1.72 2.5,1.09 8.07,1.99 10.88,2.33 0.39,0.05 1.7,0.32 1.89,0.07 0.11,-0.16 0.06,-1.82 0.06,-2.15l0 -19.78c0,-0.67 0.1,-1.47 -0.23,-1.98 -0.5,-0.77 -1.69,-1.24 -2.79,-1.62 -2.54,-0.89 -10.98,-3.02 -12.45,-4.6l-0.31 -0.27c-0.05,6.78 0.03,13.57 0,20.35 0,0.58 0.61,1.2 1.01,1.52 1.44,1.12 3.69,1.7 5.53,2.12 1.96,0.46 4.38,0.95 6.4,1.26 0.69,0.11 1.49,0.22 2.19,0.36z"
      />
      <path
        class="fil0"
        d="M24.24 20.11c-2.25,0.16 -4.09,1.34 -5.13,2.47 -0.65,0.71 -1.09,1.34 -1.47,2.3 -1,2.51 -0.65,5.28 0.9,7.46 2.08,2.92 6.36,3.71 9.58,2.18 0.52,-0.24 1.29,-0.73 1.71,-1.13 2.53,-2.38 3.11,-5.93 1.64,-9.13 -0.28,-0.62 -0.68,-1.2 -1.12,-1.7 -0.77,-0.87 -1.57,-1.48 -2.81,-1.98 -1.01,-0.4 -2.12,-0.56 -3.3,-0.47z"
      />
      <path
        class="fil0"
        d="M6.79 4.74l0.01 -2.6 17.65 0 0.01 17.02c0.34,0.01 0.68,0 1.02,0.02 0.27,0.02 0.69,0.1 0.92,0.09 0.04,-0.47 0.01,-6.48 0.01,-7.11 -0.01,-2.38 0,-4.77 0,-7.16 -0.01,-0.59 0.03,-3.17 -0.03,-3.54 -0.08,-0.49 -0.4,-0.88 -0.68,-1.09 -0.42,-0.33 -0.77,-0.37 -1.42,-0.37l-21.45 0c-0.63,0 -1.03,-0.01 -1.59,0.19 -0.47,0.17 -0.84,0.42 -1.05,0.74 -0.39,0.61 -0.09,0.89 0.28,1.18 0.3,0.23 0.74,0.5 1.13,0.69 0.79,0.38 1.66,0.74 2.52,1.05 0.38,0.13 2.42,0.89 2.67,0.89z"
      />
      <text x="22.04" y="32.56" class="fil1 fnt0">I</text>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
